var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25292 1.05016C6.55871 0.431194 7.44139 0.431196 7.74718 1.05016L9.3921 4.37974L13.0685 4.91199C13.7527 5.01105 14.0257 5.85219 13.53 6.33417L10.8661 8.92458L11.4942 12.5825C11.6111 13.2635 10.8961 13.7828 10.2847 13.4609L7.00446 11.7341L3.71458 13.4621C3.10316 13.7832 2.3889 13.2639 2.50578 12.5833L3.13404 8.92458L0.470091 6.33417C-0.0255706 5.85219 0.247411 5.01105 0.931639 4.91199L4.608 4.37974L6.25292 1.05016Z",
    fill: "#FDB058"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.6669aca9e6d90dc0e49c0b828984e725.svg";
export { ForwardRef as ReactComponent };